// // Generic OAuth carry-through helpers for integrations where OUR app is the
// // OAuth provider (Make.com today; Zapier/HubSpot if they point their consent
// // at our frontend tomorrow). Platform-agnostic — nothing here is Make-specific.
// //
// // The Rexpt onboarding runs INSIDE the popup window the provider opens
// // ("Waiting for authorization…"). The provider only closes that window when it
// // navigates to its redirect_uri carrying the SAME `code` + `state` it
// // generated. We therefore carry redirect_uri + state + platform across the
// // flow: consent → login → onboarding → /fast-step.
// //
// // Storage: localStorage. We intentionally use it (not cookies) so the OAuth
// // data is wiped on logout / localStorage.clear() — otherwise a stale value
// // lingers and the app wrongly thinks an OAuth session is still active even when
// // there is no logged-in account. NOTE: if a brand-new user goes through the
// // full onboarding (which calls localStorage.clear() in a few places) the value
// // can be cleared mid-flow; for already-logged-in users (consent → Allow →
// // redirect) this does not happen.

// const RU_KEY = "oauth_redirect_uri";
// const ST_KEY = "oauth_state";
// const PF_KEY = "oauth_platform";

// function setItem(name, value) {
//   try { localStorage.setItem(name, value); } catch {}
// }

// function getItem(name) {
//   try { return localStorage.getItem(name); } catch { return null; }
// }

// function delItem(name) {
//   try { localStorage.removeItem(name); } catch {}
// }

// // Save redirect_uri + state + platform if present in the current URL. `state`
// // may arrive under a few names depending on the upstream page, so we check all
// // of them. `platformHint` lets the consent route pass the :platform param.
// // Returns true if this looks like an OAuth provider entry.
// export function captureOAuth(search = window.location.search, platformHint = "") {
//   const qs = new URLSearchParams(search);
//   const redirectUri = qs.get("oauth_redirect_uri") || qs.get("redirect_uri");
//   const state =
//     qs.get("state") || qs.get("oauth_state") || qs.get("make_state");
//   const platform = (platformHint || qs.get("platform") || "").toLowerCase();
//   const isProvider = !!platform || !!redirectUri;

//   if (redirectUri) setItem(RU_KEY, redirectUri);
//   if (state) setItem(ST_KEY, state);
//   if (platform) setItem(PF_KEY, platform);

//   return isProvider && !!redirectUri;
// }

// export function getOAuth() {
//   return {
//     redirectUri: getItem(RU_KEY),
//     state: getItem(ST_KEY),
//     platform: getItem(PF_KEY),
//   };
// }

// export function clearOAuth() {
//   delItem(RU_KEY);
//   delItem(ST_KEY);
//   delItem(PF_KEY);
// }

// // Build the provider's callback URL and navigate to it. The provider grabs the
// // code and closes its own popup window. Returns false (and does nothing) if we
// // can't — e.g. not an OAuth session, no token yet, or state missing.
// export function returnToProvider(token) {
//   const { redirectUri, state } = getOAuth();
//   if (!redirectUri || !token) return false;

//   // Providers REJECT the callback with "Invalid URL" unless the exact state is
//   // echoed back. Redirecting without it would just reproduce that error.
//   if (!state) {
//     console.error(
//       "[oauth] state MISSING — cannot close provider popup. " +
//         "Ensure the consent step ran and captured `state`."
//     );
//     return false;
//   }

//   const back = new URL(redirectUri);
//   back.searchParams.set("code", token);
//   back.searchParams.set("state", state);

//   clearOAuth();
//   console.log("[oauth] returning to provider →", back.toString());
//   window.location.replace(back.toString());
//   return true;
// }

// // ── HubSpot secure-install return ──────────────────────────────────────────
// // DIFFERENT from returnToProvider(): for HubSpot WE are the OAuth *client*, so
// // the code was already exchanged server-side. HubSpot hands us a one-shot
// // `returnUrl` (carried through to the success page as `hubspotReturnUrl`);
// // navigating to it finalizes the marketplace install — closes the install popup
// // AND ticks "Complete" on HubSpot's side. We stash it when the user lands on the
// // success page and fire it ONLY AFTER an agent exists, so the popup stays open
// // through onboarding.
// //
// // Stored in localStorage via the SAME setItem/getItem helpers the Zapier/Make
// // flow uses (RU_KEY/ST_KEY above) — one consistent mechanism for every provider.
// const HS_KEY = "hubspot_return_url";

// function isHubspotUrl(value) {
//   try {
//     const u = new URL(value);
//     return (
//       u.protocol === "https:" &&
//       (u.hostname === "hubspot.com" || u.hostname.endsWith(".hubspot.com"))
//     );
//   } catch {
//     return false;
//   }
// }

// // Read `hubspotReturnUrl` from the current URL and stash it (only if it's a valid
// // HubSpot https URL). Call on the success page. Returns true if captured.
// export function captureHubspotReturn(search = window.location.search) {
//   const url = new URLSearchParams(search).get("hubspotReturnUrl");
//   if (!url || !isHubspotUrl(url)) return false;
//   setItem(HS_KEY, url);
//   return true;
// }

// // If a HubSpot install is pending, send the user back to HubSpot to finalize it
// // (closes the popup + ticks "Complete"). No-op (returns false) otherwise. Call
// // once an agent is confirmed to exist. Re-validates the host before redirecting.
// export function returnToHubspot() {
//   const url = getItem(HS_KEY);
//   if (!url || !isHubspotUrl(url)) return false;
//   delItem(HS_KEY);
//   console.log("[oauth] returning to HubSpot to finalize install →", url);
//   window.location.replace(url);
//   return true;
// }
// Generic OAuth carry-through helpers for integrations where OUR app is the
// OAuth provider (Make.com today; Zapier/HubSpot if they point their consent
// at our frontend tomorrow). Platform-agnostic — nothing here is Make-specific.
//
// The Rexpt onboarding runs INSIDE the popup window the provider opens
// ("Waiting for authorization…"). The provider only closes that window when it
// navigates to its redirect_uri carrying the SAME `code` + `state` it
// generated. We therefore carry redirect_uri + state + platform across the
// flow: consent → login → onboarding → /fast-step.
//
// Storage: localStorage. We intentionally use it (not cookies) so the OAuth
// data is wiped on logout / localStorage.clear() — otherwise a stale value
// lingers and the app wrongly thinks an OAuth session is still active even when
// there is no logged-in account. NOTE: if a brand-new user goes through the
// full onboarding (which calls localStorage.clear() in a few places) the value
// can be cleared mid-flow; for already-logged-in users (consent → Allow →
// redirect) this does not happen.

const RU_KEY = "oauth_redirect_uri";
const ST_KEY = "oauth_state";
const PF_KEY = "oauth_platform";

// Per-window tag marking THIS tab as an integration OAuth popup. sessionStorage
// is per-window, so an ordinary app tab never carries it — that is what stops a
// stale redirect_uri sitting in shared localStorage from hijacking a normal
// visit and throwing the user out to the provider.
//
// Make has read/written this key inline since before HubSpot needed it, and that
// inline code is deliberately LEFT ALONE — these helpers exist for HubSpot only,
// so the Make/Zapier path stays byte-identical. Both share the same key string on
// purpose: Onboarding.js and SecureRoute.js preserve that literal across their
// sessionStorage.clear(), so a separate key would be silently dropped
// mid-onboarding and the return would break.
const POPUP_TAG = "make_oauth_popup";

function markOAuthPopup() {
  try {
    sessionStorage.setItem(POPUP_TAG, "1");
  } catch {}
}

function isOAuthPopup() {
  try {
    return sessionStorage.getItem(POPUP_TAG) === "1";
  } catch {
    return false;
  }
}

function setItem(name, value) {
  try {
    localStorage.setItem(name, value);
  } catch {}
}

function getItem(name) {
  try {
    return localStorage.getItem(name);
  } catch {
    return null;
  }
}

function delItem(name) {
  try {
    localStorage.removeItem(name);
  } catch {}
}

// Guard against the LITERAL text "null" / "undefined" ending up in a query
// param (e.g. a caller building `?state=${userId}` when userId is JS
// null/undefined turns it into the STRING "null", which is truthy and would
// otherwise be stored/forwarded as if it were a real state value). Treat those
// — plus actually-empty values — as "no value".
function sanitize(value) {
  if (!value) return null;
  const trimmed = String(value).trim();
  if (!trimmed || trimmed === "null" || trimmed === "undefined") return null;
  return trimmed;
}

// Save redirect_uri + state + platform if present in the current URL. `state`
// may arrive under a few names depending on the upstream page, so we check all
// of them. `platformHint` lets the consent route pass the :platform param.
// Returns true if this looks like an OAuth provider entry.
export function captureOAuth(
  search = window.location.search,
  platformHint = "",
) {
  const qs = new URLSearchParams(search);
  const redirectUri = sanitize(
    qs.get("oauth_redirect_uri") || qs.get("redirect_uri"),
  );
  const state = sanitize(
    qs.get("state") || qs.get("oauth_state") || qs.get("make_state"),
  );
  const platform =
    sanitize(platformHint || qs.get("platform") || "")?.toLowerCase() || "";
  const isProvider = !!platform || !!redirectUri;

  if (redirectUri) setItem(RU_KEY, redirectUri);
  if (state) setItem(ST_KEY, state);
  if (platform) setItem(PF_KEY, platform);

  // MAKE ONLY — tag THIS window as the Make OAuth popup, but only when the Make
  // params actually arrived in the URL (the provider's popup landing on the consent
  // page). sessionStorage is per-window, so the normal Rexpt app tab never gets this
  // tag. returnToProvider() requires it before redirecting to make.com, so a STALE
  // oauth_redirect_uri left in shared localStorage (user closed the popup without
  // connecting) can no longer hijack a normal dashboard visit ("Resource not found").
  if (isProvider && redirectUri && platform === "make") {
    try { sessionStorage.setItem("make_oauth_popup", "1"); } catch {}
  }

  return isProvider && !!redirectUri;
}

export function getOAuth() {
  return {
    redirectUri: getItem(RU_KEY),
    state: getItem(ST_KEY),
    platform: getItem(PF_KEY),
  };
}

export function clearOAuth() {
  delItem(RU_KEY);
  delItem(ST_KEY);
  delItem(PF_KEY);
}

// Build the provider's callback URL and navigate to it. The provider grabs the
// code and closes its own popup window. Returns false (and does nothing) if we
// can't — e.g. not an OAuth session, no token yet, or state missing.
export function returnToProvider(token) {
  const { redirectUri, state, platform } = getOAuth();

  // HUBSPOT — same keys, different direction. For HubSpot we are the OAuth
  // CLIENT: the code was already exchanged server-side and HubSpot handed us a
  // one-shot finalize URL, so we navigate to it VERBATIM. Appending code+state
  // (what the provider branch below does) would break it.
  //
  // Sits ABOVE the guard below and does its own `redirectUri` check, so that
  // guard line stays exactly as it was — no rewrite of the Make/Zapier path.
  // HubSpot carries no token of ours, so it must not be gated on `token`.
  if (redirectUri && (platform || "").toLowerCase() === "hubspot") {
    if (!isHubspotUrl(redirectUri)) {
      clearOAuth();
      return false;
    }
    // Same stale-value guard Make needs, for the same reason. An abandoned
    // install leaves these keys behind, and they now SURVIVE onboarding's
    // localStorage.clear() (the oauth_* keys are restored by name) — so without
    // this, opening the dashboard days later would throw the user out to a dead
    // HubSpot install URL. Only the popup that ran the install carries the tag.
    if (!isOAuthPopup()) {
      clearOAuth();
      return false;
    }
    // HubSpot's docs: redirect back as `${returnUrl}?state=${state}` when the
    // install supplied a state token. Plain installs send none — then the URL
    // goes back untouched, since it already carries its own params.
    let back = redirectUri;
    if (state) {
      const u = new URL(redirectUri);
      u.searchParams.set("state", state);
      back = u.toString();
    }
    clearOAuth();
    console.log("[oauth] returning to HubSpot to finalize install →", back);
    window.location.replace(back);
    return true;
  }

  if (!redirectUri || !token) return false;

  // MAKE ONLY — a stale Make redirect_uri lingers in shared localStorage even when
  // the user closed the consent popup WITHOUT connecting. On a normal dashboard
  // visit that would wrongly bounce the user to make.com/oauth/cb ("Resource not
  // found"). So for Make we require the per-window popup tag set on the consent page
  // (see captureOAuth). The normal Rexpt app tab never has it → we do NOT redirect,
  // and we clear the stale keys so they can't linger. Zapier and every other
  // provider are UNAFFECTED — they skip this block entirely.
  if ((platform || "").toLowerCase() === "make") {
    let inPopup = false;
    try { inPopup = sessionStorage.getItem("make_oauth_popup") === "1"; } catch {}
    if (!inPopup) {
      clearOAuth();
      return false;
    }
  }

  // Providers REJECT the callback with "Invalid URL" unless the exact state is
  // echoed back. Redirecting without it would just reproduce that error.
  if (!state) {
    console.error(
      "[oauth] state MISSING — cannot close provider popup. " +
        "Ensure the consent step ran and captured `state`.",
    );
    return false;
  }

  const back = new URL(redirectUri);
  back.searchParams.set("code", token);
  back.searchParams.set("state", state);

  clearOAuth();
  console.log("[oauth] returning to provider →", back.toString());
  window.location.replace(back.toString());
  return true;
}

// ── HubSpot secure-install return ──────────────────────────────────────────
// DIFFERENT from returnToProvider(): for HubSpot WE are the OAuth *client*, so
// the code was already exchanged server-side. HubSpot hands us a one-shot
// `returnUrl` (carried through to the success page as `hubspotReturnUrl`);
// navigating to it finalizes the marketplace install — closes the install popup
// AND ticks "Complete" on HubSpot's side. We stash it when the user lands on the
// success page and fire it ONLY AFTER an agent exists, so the popup stays open
// through onboarding.
//
// STORAGE: the SAME oauth_redirect_uri / oauth_platform keys every other
// integration uses — HubSpot gets no key of its own.
//
// It used to have one ("hubspot_return_url"), and that was the bug: Onboarding.js
// and SecureRoute both run localStorage.clear() + sessionStorage.clear() and then
// restore only the oauth_* keys BY NAME. Zapier and Make survive that because
// they are on those lists; the HubSpot key never was, so a new user's returnUrl
// was wiped mid-onboarding and the marketplace install never ticked "Complete".
// Sharing the keys fixes it everywhere at once and keeps one mechanism to reason
// about — including "only one integration is ever pending", which now falls out
// of last-writer-wins instead of needing cross-checks between two stores.

function isHubspotUrl(value) {
  try {
    const u = new URL(value);
    return (
      u.protocol === "https:" &&
      (u.hostname === "hubspot.com" || u.hostname.endsWith(".hubspot.com"))
    );
  } catch {
    return false;
  }
}

// Read `hubspotReturnUrl` from the current URL and stash it (only if it's a valid
// HubSpot https URL). Call on the success page. Returns true if captured.
export function captureHubspotReturn(search = window.location.search) {
  const url = sanitize(new URLSearchParams(search).get("hubspotReturnUrl"));
  if (!url || !isHubspotUrl(url)) return false;
  setItem(RU_KEY, url);
  setItem(PF_KEY, "hubspot");
  // This page IS the install popup, so tag the window. returnToProvider() needs
  // it before it will navigate back to HubSpot; a normal app tab never has it.
  markOAuthPopup();
  // HubSpot's partner-sign-in variant sends an install token that must come back
  // as `${returnUrl}?state=${state}`. It rides the same ST_KEY every provider
  // uses. Absent on the plain install — then we navigate to returnUrl as-is, and
  // any state left from an earlier provider attempt is dropped so it can't be
  // mistaken for this install's.
  const installState = sanitize(
    new URLSearchParams(search).get("hubspotState"),
  );
  if (installState) setItem(ST_KEY, installState);
  else delItem(ST_KEY);
  return true;
}

// If a HubSpot install is pending, send the user back to HubSpot to finalize it
// (closes the popup + ticks "Complete"). No-op (returns false) otherwise. Call
// once an agent is confirmed to exist. Re-validates the host before redirecting.
// Kept as a named entry point for the call sites that try HubSpot first
// (Dashboard, FastAgentDetails). It just delegates: the platform tag decides, so
// if the pending loop belongs to Make or Zapier this is a no-op and those flows
// carry on to returnToProvider() untouched.
export function returnToHubspot() {
  if ((getOAuth().platform || "").toLowerCase() !== "hubspot") return false;
  return returnToProvider();
}
